import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { ContractsResponse } from './contract.model';

@Injectable({
  providedIn: 'root',
})
export class ContractsService extends Query<ContractsResponse> {
  document = gql`
    query ContractListQuery($limit: Int!) {
      contracts(limit: $limit) {
        _id
        createdAt
        contract_number
        buyer_id
        seller_id
        lot_type
        commodity
        product_type
        grade
        specifications {
          title
          value
        }
        price {
          __typename
          ... on CashPrice {
            amount
          }

          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value
        units
        ship_begin
        ship_end
        destination
        delivery_type
        buyer_company_name
        buyer_first_name
        buyer_last_name
        seller_company_name
        seller_first_name
        seller_last_name
      }
    }
  `;
}
